import React from 'react';
import { Box, Typography } from '@mui/material';

interface SettingsSectionProps {
  title: string;
  children: React.ReactNode;
}

export const SettingsSection: React.FC<SettingsSectionProps> = ({ title, children }) => (
  <Box
    component="fieldset"
    sx={{
      border: 1,
      borderColor: 'divider',
      borderRadius: 1,
      p: 2,
      pt: 2.5,
      m: 0,
      minWidth: 0,
      background: 'inherit',
    }}
  >
    <Typography
      component="legend"
      variant="subtitle2"
      sx={{
        px: 0.75,
        color: 'text.secondary',
        lineHeight: 1.2,
        background: 'inherit',
      }}
    >
      {title}
    </Typography>
    {children}
  </Box>
);
